import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgGiftIconSecondary from './svgs/GiftIconSecondary.js';
import SvgGiftIcon from './svgs/GiftIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var giftIcon = (props => useIcon(SvgGiftIcon, SvgGiftIconSecondary, props));

export { giftIcon as default };
